import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, LoadingController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';

@IonicPage()
@Component({
  selector: 'page-crop-image',
  templateUrl: 'crop-image.html',
})
export class CropImagePage {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imageFile: any;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public af: AngularFirestore, public afa: AngularFireAuth) { }

  cancel() {
    this.navCtrl.pop();
  }

  ionViewDidLoad() { }

  fileChangeEvent(event: any): void {
    if (event && event.target && event.target.value) {
      this.imageChangedEvent = event;
      this.imageFile = event.target.files[0];
    }
  }

  imageCropped(event: any) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }

  loadImageFailed(err) {
    ////console.error(err);
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  save() {
    this.presentLoadingCustom();
    this.uploadFileSStorage(this.croppedImage, this.imageFile).then(data => {
      this.af.doc("Users/" + this.afa.auth.currentUser.uid).ref.get().then(doc => {
        if (doc.get('profile') && doc.get('profile').fullPath) {
          var storageRef = firebase.storage().ref();
          storageRef.child(doc.get('profile').fullPath).delete().then(() => {
            doc.ref.update({ "profile": data }).then(() => {
              this.loading.dismiss();
              this.presentToast("Perfil Actualizado correctamente!");
              this.navCtrl.pop();
            }).catch(error => {
              this.loading.dismiss();
              this.presentToast("Ha ocurrido un error!");
              ////console.error(error);
            });
          }).catch(error => {
            ////console.error(error);
            doc.ref.update({ "profile": data }).then(() => {
              this.loading.dismiss();
              this.presentToast("Perfil Actualizado correctamente!");
              this.navCtrl.pop();
            }).catch(error => {
              this.loading.dismiss();
              this.presentToast("Ha ocurrido un error!");
              ////console.error(error);
            });
          });
        } else {
          doc.ref.update({ "profile": data }).then(() => {
            this.loading.dismiss();
            this.presentToast("Perfil Actualizado correctamente!");
            this.navCtrl.pop();
          }).catch(error => {
            this.loading.dismiss();
            this.presentToast("Ha ocurrido un error!");
            ////console.error(error);
          });
        }
      }).catch(error => {
        this.loading.dismiss();
        this.presentToast("Ha ocurrido un error!");
        ////console.error(error);
      });
    }).catch(error => {
      ////console.error(error);
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
    });
  }

  async uploadFileSStorage(croppedImage: any, file: any): Promise<any> {
    let fileRet: any;
    var storageRef = firebase.storage().ref();
    var fileRef = storageRef.child('imgProfiles/' + new Date().getTime() + file.name);
    await fileRef.putString(croppedImage, 'data_url').then(function (res) {
      fileRet = { "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath }
    });
    return fileRet;
  }

}



// WEBPACK FOOTER //
// ./src/pages/crop-image/crop-image.ts